import React, { useEffect, useRef, useState } from 'react';
import '../../styles/Sections.scss';
import '../../styles/Course.scss';
import Logo from '../Logo';
import KnowledgeCheckList from '../KnowledgeCheckList';
import { useAuthContext } from '../../context/authContext';
import bounceBack from '../../assets/bounceback.svg';

const DemoScreener = ({ section, stopVideo, fromFavorites }) => {

  const {
    state: { user },
  } = useAuthContext();

  const [isStart, setIsStart] = useState(false);
  const [knowledgeCheckData, setKnowledgeCheckData] = useState([]);

  useEffect(() => {
    setIsStart(true);
    setKnowledgeCheckData(data);
  }, []);


  const data = [
    {
      "id": 38,
      "name": "Measure Your Stress",
      "is_order_random": false,
      "module_section": {
        "id": 135,
        "course_module_id": 53,
        "name": "Screener1",
        "description": "",
        "created_at": "2022-12-21T20:41:42.024Z",
        "updated_at": "2022-12-21T20:42:19.195Z",
        "knowledge_check_url": "http://localhost/api/v1/knowledge_checks?module_section_id=135",
        "status": 0,
        "order": 1
      },
      "knowledge_check_questions_options_answers": [
        {
          "id": 135,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you been upset because of something that happened unexpectedly?",
          "created_at": "2022-12-23T20:23:25.197Z",
          "updated_at": "2022-12-23T20:24:16.001Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 395,
              "knowledge_check_question_id": 135,
              "name": "Never",
              "created_at": "2022-12-23T20:23:25.299Z",
              "updated_at": "2022-12-23T20:24:16.212Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 136,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you felt that you were unable to control the important things in your life?",
          "created_at": "2022-12-23T20:24:37.220Z",
          "updated_at": "2022-12-23T20:24:37.220Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 396,
              "knowledge_check_question_id": 136,
              "name": "Never",
              "created_at": "2022-12-23T20:24:37.326Z",
              "updated_at": "2022-12-23T20:24:37.326Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 137,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you felt nervous and stressed?",
          "created_at": "2022-12-23T20:25:13.600Z",
          "updated_at": "2022-12-23T20:25:13.600Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 397,
              "knowledge_check_question_id": 137,
              "name": "Never",
              "created_at": "2022-12-23T20:25:13.714Z",
              "updated_at": "2022-12-23T20:25:13.714Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 138,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you felt confident about your ability to handle your personal problems?",
          "created_at": "2022-12-23T20:25:43.935Z",
          "updated_at": "2022-12-23T20:25:43.935Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 398,
              "knowledge_check_question_id": 138,
              "name": "Never",
              "created_at": "2022-12-23T20:25:44.050Z",
              "updated_at": "2022-12-23T20:25:44.050Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 139,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you felt that things were going your way?",
          "created_at": "2022-12-23T20:26:08.747Z",
          "updated_at": "2022-12-23T20:26:08.747Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 399,
              "knowledge_check_question_id": 139,
              "name": "Never",
              "created_at": "2022-12-23T20:26:08.853Z",
              "updated_at": "2022-12-23T20:26:08.853Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 140,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you found that you could not cope with all the things that you had to do?",
          "created_at": "2022-12-23T20:26:24.054Z",
          "updated_at": "2022-12-23T20:26:24.054Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 400,
              "knowledge_check_question_id": 140,
              "name": "Never",
              "created_at": "2022-12-23T20:26:24.174Z",
              "updated_at": "2022-12-23T20:26:24.174Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 141,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you been able to control irritations in your life?",
          "created_at": "2022-12-23T20:26:49.385Z",
          "updated_at": "2022-12-23T20:26:49.385Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 401,
              "knowledge_check_question_id": 141,
              "name": "Never",
              "created_at": "2022-12-23T20:26:49.506Z",
              "updated_at": "2022-12-23T20:26:49.506Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 142,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you felt that you were on top of things?",
          "created_at": "2022-12-23T20:28:32.722Z",
          "updated_at": "2022-12-23T20:28:32.722Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 402,
              "knowledge_check_question_id": 142,
              "name": "Never",
              "created_at": "2022-12-23T20:28:32.856Z",
              "updated_at": "2022-12-23T20:28:32.856Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 143,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you been angered because of things that were outside of your control?",
          "created_at": "2022-12-23T20:28:54.462Z",
          "updated_at": "2023-01-25T16:34:12.402Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 403,
              "knowledge_check_question_id": 143,
              "name": "Never",
              "created_at": "2022-12-23T20:28:54.591Z",
              "updated_at": "2022-12-23T20:28:54.591Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        },
        {
          "id": 144,
          "knowledge_check_id": 38,
          "name": "In the last month, how often have you felt difficulties were piling up so high that you could not overcome them?",
          "created_at": "2022-12-23T20:33:14.883Z",
          "updated_at": "2022-12-23T20:33:14.883Z",
          "multiple": false,
          "knowledge_check_options": [
            {
              "id": 404,
              "knowledge_check_question_id": 144,
              "name": "Never",
              "created_at": "2022-12-23T20:33:15.054Z",
              "updated_at": "2022-12-23T20:33:15.054Z",
              "correct": true
            }
          ],
          "knowledge_check_answers": []
        }
      ],
      "has_pending_checks": true,
      "has_pending_checks_score": 0,
      "created_at": "2022-12-21T20:33:26.934Z",
      "updated_at": "2023-01-20T16:23:29.434Z",
      "url": "http://localhost:3001/api/v1/knowledge_checks/38"
    }
  ];

  const goBack = () => {
    setIsStart(true);
    setKnowledgeCheckData(data);
  };

  useEffect(() => {
    setIsStart(true);
    setKnowledgeCheckData(data);
  }, []);

  return (
    <>
      {isStart ? (

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
          minHeight: '100vh',
          paddingTop: '20px',
          paddingLeft: '25px',
          paddingRight: '25px',
        }}>
          <div style={{
            width: '200px',
            height: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <Logo />
          </div>

          <div
            className="mt-4 card"
            style={{
              width: '100%',
              //maxWidth: '800px',
              marginBottom: '25px',
              borderRadius: '15px',
            }}
          >
            <KnowledgeCheckList
              module={null}
              section={null}
              content={knowledgeCheckData}
              goBack={goBack}
              isDemo={true}
            />
          </div>
        </div>

      ) : (
        // OR
        ''
      )}

    </>
  );
};

export default DemoScreener;